import { render, staticRenderFns } from "./ProposalConfirm.vue?vue&type=template&id=377af770&"
import script from "./ProposalConfirm.vue?vue&type=script&lang=js&"
export * from "./ProposalConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports